import { API, graphqlOperation } from 'aws-amplify';

export default {
    namespaced: true,
    state: {
        list: null,
        item: null,
        nextToken: null
    },
    mutations: {
        list: (state, payload) =>{ state.list = payload.append ? (state.list || []).concat(payload.value) : payload.value },
        item: (state, payload) => { state.item = payload.value },
        nextToken: (state, payload) => { state.nextToken = payload.value },
    },
    actions: {
        async list(context, payload) {
            const f = await API.graphql(graphqlOperation(/* GraphQL */ `
            query ($domainID: ID!) {
                leadFormsByDomainName(domainID: $domainID) {
                  items {
                    id
                    name
                    tagID
                  }
                  nextToken
                }
              }`, payload));
              
              let items = f.data.leadFormsByDomainName.items;
              
            context.commit('list', {value: items, append: !!payload?.nextToken });
            context.commit('nextToken', {value: f.data.leadFormsByDomainName.nextToken });
          if(context.state.nextToken) {
            await context.dispatch('list', { ...payload, nextToken: context.state.nextToken });
          }
        },

        async get(context, payload) {
            const f = await API.graphql(graphqlOperation(/* GraphQL */ `
            query GetForm($id: ID!) {
                getLeadForm(id: $id) {
                    id
                    name
                    tag {
                        id
                        name
                    }
                    optinFriendlyFrom
                    optinFrom
                    optinReplyTo
                    optinEmail {
                        buttonColor
                        buttonText
                        heading
                        logo
                        text
                        title
                    }
                    optinRedirect
                    optinPage {
                        heading
                        logo
                        text
                        title
                    }
                    
                    thxRedirect
                    thxPage {
                        heading
                        logo
                        text
                        title
                    }
                    config
                }
              }`, { id: payload.id }));
              context.commit('item', { value: f.data.getLeadForm });
        },

        async create(context, payload) {
            let tag = await API.graphql(graphqlOperation(`
            mutation CreateLeadForm(
              $input: CreateLeadFormInput!
            ) {
              createLeadForm(input: $input) {
                id
                name
              }
            }
          `, { input: { name: payload.name,
            tagID: payload.tag, 
            domainID: payload.domain.id,
            optinFriendlyFrom: payload.domain.friendlyFrom,
            optinFrom: payload.domain.from,
            optinReplyTo: payload.domain.replyTo, 
            editors: [payload.domain.owner, ...(payload.domain.editors || [])],
          }}));
          await context.dispatch('list', { domainID: payload.domain.id });
          return tag.data.createLeadForm;
        },

        async updateFields(context, payload) {
            await API.graphql(graphqlOperation(`
              mutation UpdateLeadForm(
                $input: UpdateLeadFormInput!
                $condition: ModelLeadFormConditionInput
              ) {
                updateLeadForm(input: $input, condition: $condition) {
                  id
                }
              }
            `, { input: Object.assign({ id: context.state.item.id }, payload.fields )}));
            return context.dispatch('get', { id: context.state.item.id });
            //return r.data.updateDomain;
          },
    }
}